import {Injectable} from "@angular/core";
import { Route, Router, UrlSegment } from "@angular/router";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers/reducer";
import {map,} from "rxjs";
import {canNavigate} from "../../selectors/auth.selector";
import {take} from "rxjs/operators";
import {StradiaRoutes} from "../../../shared/enum/routes.enum";

@Injectable()
export class CanLoadGuard  {
  constructor(
    private store: Store<AppState>,
    private router: Router,
  ) { }

  canLoad(route: Route, segments: UrlSegment[]) {
    return this.store.select(canNavigate).pipe(
      take(1),
      map(can => {
        // debugger
        if (!can) {
          if(localStorage.getItem(`isRefreshing`) !== 'true') {
            this.router.navigate([`/${StradiaRoutes.LOGIN}`]);
          }
          // this.store.dispatch(logout());
          return false;
        }
        return true;
      })
    );
  }
}
